<template>
  <div>
    <h2 class="mb-6 text-uppercase text-center">
      Premium Business
    </h2>
    <h4 class="mb-2">
      10 SubUsers | 500 Credits | 50GB storage limit
    </h4>
    <p>Medium business features plus:</p>
    <ul class="mb-6">
      <li>Generate on behalf of multiple group entities</li>
      <li>Detailed Registry access permissions</li>
      <li>Contracting on behalf of 3 group entities</li>
      <li>Management reporting</li>
    </ul>
    <p>
      Suit larger businesses who require regular legal and compliance
      documentation.
    </p>
  </div>
</template>
<script>
export default {
  name: 'MediumBusinessPlanDescription'
}
</script>
<style lang="sss" scoped></style>
